export default __webpack_public_path__ + "static/composer-video-poster-466d421a84f33bc80d3f0974112a1a90.png";